import React, { useState, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import styles from './index.module.scss'
import { IOrderItem, IRemark } from '../../../../../network/models/OrderTypes'
import { OP_BTNS } from '../../../../../config/index'
import OptModal from '../OptModal'
import LookAroundTip from '../LookAroundTip'
import request from '../../../../../network/request'
import { getStatusValByKey } from '../../common'
interface IProps {
  orderInfo: IOrderItem
  onRefresh: () => any
}

export default function OrderItem({ orderInfo, onRefresh }: IProps) {
  const history = useHistory()
  const [showOptModal, setShowOptModal] = useState(false)
  const [showLookAroundTip, setShowLookAroundTip] = useState(false)
  const [opType, setOpType] = useState('')
  const [order, setOrder] = useState<any>({})
  const [isOpting, setIsOpting] = useState(false)

  const handleLinkToDetail = (id: number) => {
    history.push(`/ms/detail/${id}`)
  }

  const handleLinkToConfirm = (id: number) => {
    history.push(`/ms/confirm/${id}`)
  }

  const handleClickOpt = (
    event: React.MouseEvent,
    op: string,
    orderInfo: any
  ) => {
    event.stopPropagation()

    if (op === 'finish') {
      handleRequestFinish(orderInfo)
    } else if (op === 'lookaround') {
      setOrder(orderInfo)
      setShowLookAroundTip(true)
    } else if (op === 'confirm') {
      handleLinkToConfirm(orderInfo.id)
    } else {
      setShowOptModal(true)
      setOpType(op)
      setOrder(orderInfo)
    }
  }

  const handleRequestFinish = async (orderInfo: any) => {
    if (isOpting) {
      return
    }

    setIsOpting(true)
    try {
      await request.post('/dragon/service/order/operate', {
        operateType: 'finish',
        serviceOrderId: orderInfo.id,
      })
      setShowOptModal(true)
      setOpType('finish')
      setOrder(orderInfo)
    } catch (err) {
      console.log(err)
    } finally {
      setIsOpting(false)
    }
  }

  const handleCloseOpt = () => {
    setShowOptModal(false)
  }

  const emitRefreshData = () => {
    onRefresh()
  }

  const handleCloseLookAround = () => {
    setShowLookAroundTip(false)
  }

  const handleCall = (e) => {
    e.stopPropagation()

    if (window.xdragon) {
      window.xdragon.callHandler('h5callPhone', {
        phone: orderInfo.reserveMobile,
      })
    }
  }

  const handleLinkToDrgon = async (e) => {
    e.stopPropagation()

    if (window.xdragon) {
      try {
        await window.xdragon.callHandler('sendMessage', {
          accId: orderInfo.tid,
          type: 'team',
        })
      } catch (err) {
        console.log(err)
      }
    }
  }

  const handleNav = (e) => {
    e.stopPropagation()

    if (window.xdragon) {
      window.xdragon.callHandler('openMap', {
        lat: orderInfo.reserveLat,
        lng: orderInfo.reserveLng,
        addr: orderInfo.reserveAddress,
      })
    }
  }

  const showDragonLink = useMemo(() => {
    return (
      orderInfo.tid &&
      ((orderInfo.orderType === 'mobile' &&
        orderInfo.status > 1 &&
        orderInfo.status !== 4 &&
        orderInfo.status < 12) ||
        (orderInfo.orderType !== 'mobile' && orderInfo.status < 12))
    )
  }, [orderInfo])

  return (
    <div
      className={styles.orderItemWrap}
      onClick={() => handleLinkToDetail(orderInfo.id)}
    >
      <div className={styles.blockItem}>
        <div className={styles.vehicleInfo}>
          <p>订单号: {orderInfo.id}</p>
          <p>车架号: {orderInfo.vin}</p>
        </div>
      </div>
      <div className={[styles.blockItem, styles.decorate].join(' ')}>
        <div className={styles.customInfo}>
          <div className={styles.nameStatus}>
            <p className={styles.name}>{orderInfo.reserveName}</p>
            <div className={styles.labelContainer}>
              <p className={styles.typeLabel}>
                {orderInfo.orderType === 'mobile' ? '移动服务' : '远程服务'}
                {orderInfo.stationName && (
                  <span> • {orderInfo.stationName}</span>
                )}
              </p>
              {getStatusValByKey(
                orderInfo.status,
                orderInfo.orderType,
                'label'
              ) && (
                <p
                  className={[
                    styles.statusLabel,
                    styles[
                      getStatusValByKey(
                        orderInfo.status,
                        orderInfo.orderType,
                        'labelType'
                      )
                    ],
                  ].join(' ')}
                >
                  {getStatusValByKey(
                    orderInfo.status,
                    orderInfo.orderType,
                    'label'
                  )}
                </p>
              )}
            </div>
          </div>
          <div className={styles.contact}>
            <p className={styles.mobile} onClick={handleCall}>
              {orderInfo.reserveMobile}
            </p>
            {showDragonLink && (
              <p className={styles.xdragon} onClick={handleLinkToDrgon}></p>
            )}
          </div>
          <div className={styles.address} onClick={handleNav}>
            <div className={styles.iconAddress}></div>
            <p className={styles.addressDetail}>{orderInfo.reserveAddress}</p>
            <div className={styles.iconArrow}></div>
          </div>
        </div>
      </div>
      <div className={styles.blockItem}>
        <div className={styles.orderSummary}>
          <div className={styles.reserveInfo}>
            <p className={styles.reserveTime}>
              预约时间: {orderInfo.reserveTime}
              {orderInfo.orderType !== 'mobile' && orderInfo.reserveEndTime && (
                <span> -- {orderInfo.reserveEndTime}</span>
              )}
            </p>
            {orderInfo.orderType === 'mobile' && (
              <p>服务车辆: {orderInfo.serviceVehiclePlateNo}</p>
            )}
          </div>
          <div className={styles.remarkWrap}>
            {orderInfo.remarks?.map((remark: IRemark, remarkIndex) => {
              return (
                remarkIndex <= 1 && (
                  <div key={remarkIndex} className={styles.remarkItem}>
                    {remark.createRoleName && (
                      <div className={styles.remarkRole}>
                        {remark.createRoleName}
                      </div>
                    )}
                    <div className={styles.remarkName}>
                      {remark.createName}：{' '}
                    </div>
                    <p className={styles.remarkContent}>{remark.remark}</p>
                  </div>
                )
              )
            })}
            {orderInfo.status < 12 && (
              <div
                className={[
                  styles.addRemark,
                  orderInfo?.remarks?.length > 0 ? styles.borderTop : '',
                ].join(' ')}
                onClick={(e) => handleClickOpt(e, 'addRemark', orderInfo)}
              >
                <div className={styles.drawIcon}></div>
                <p className={styles.desc}>输入备注信息</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={styles.blockItem}>
        <div className={styles.opWrap}>
          {`${getStatusValByKey(
            orderInfo.status,
            orderInfo.orderType,
            'optList'
          )}`
            ?.split(',')
            ?.map((op) => {
              return (
                op && (
                  <div
                    key={op}
                    className={[styles.opBtn, styles[op]].join(' ')}
                    onClick={(e) => handleClickOpt(e, op, orderInfo)}
                  >
                    <div className={styles.icon}></div>
                    <span> {OP_BTNS[op as keyof typeof OP_BTNS]}</span>
                  </div>
                )
              )
            })}
        </div>
      </div>
      {showOptModal && (
        <OptModal
          opType={opType}
          order={order}
          onClose={handleCloseOpt}
          onRefreshData={emitRefreshData}
        ></OptModal>
      )}
      {showLookAroundTip && (
        <LookAroundTip
          order={order}
          onClose={handleCloseLookAround}
        ></LookAroundTip>
      )}
    </div>
  )
}
